import API from "../api";

export const getHelpDeskDetails = () => API.agent().get(`/help-desk`);
